<template>

      
  <div class="speaking-video-list">
    <v-card>
      <v-card-title style="display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0;">Lms Video Management</h3>
        <v-btn
          color="primary"
          @click="exportToCSV"
          class="export-button"
        >
          Export
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout wrap align-center style="padding: 10px 0; margin-bottom: 20px;">
          <v-flex xs12 md6 style="padding-right: 15px;">
            <v-text-field
              v-model="filterUserId"
             
              placeholder="Search by User ID..."
              clearable
              @input="onFilterChange"
              @keyup.enter="fetchSpeakingVideos"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 style="padding-left: 15px;">
            <v-select
              v-model="filterStatus"
              :items="statusItems"
              label="Status"
              item-text="text"
              item-value="value"
              clearable
              @change="onFilterChange"
            ></v-select>
          </v-flex>
          <v-flex xs6 md6  style="padding-right: 15px">
                <i-datepicker
                    v-model="fromDate"
                    label="Từ ngày"
                    clearable
                    @change="onFilterChange"
                />
          </v-flex>
          <v-flex xs6 md6 style="padding-left: 15px;">
                <i-datepicker
                    v-model="toDate"
                    label="Đến ngày"
                    clearable
                    @change="onFilterChange"
                />
          </v-flex>
        </v-layout>
        <div class="table-wrapper">
          <v-data-table
              :key="tableKey"
              :headers="headers"
              :items="speakingVideos"
              :loading="loading"
              item-key="id"
              :rows-per-page-items="[10, 25, 50, 100]"
              :pagination.sync="pagination"
              :total-items="totalItems"
              loading-text="Đang tải... Vui lòng đợi"
              class="elevation-1"
          >
          <template v-slot:items="props">
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">{{ props.item.userId || '-' }}</td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">
              <div v-if="props.item.thumbnailUrl || props.item.videoUrl" 
                   class="video-thumbnail-container"
                   @mouseenter="showVideo($event, props.item.videoUrl)"
                   @mouseleave="hideVideo($event)"
                   @click="openVideoPopup(props.item.videoUrl)">
                <img
                  v-if="props.item.thumbnailUrl"
                  :src="props.item.thumbnailUrl"
                  :alt="'Video thumbnail'"
                  class="video-thumbnail"
                />
                <video
                  v-if="props.item.videoUrl"
                  :src="props.item.videoUrl"
                  class="video-preview"
                  loop
                  preload="metadata"
                ></video>
              </div>
              <span v-else>-</span>
            </td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">{{ getDisplayStatus(props.item.status) || '-' }}</td>
            <td class="feedback-text-col" :class="{ 'edited-cell': editedRowId === props.item.id }" style="text-align: justify !important;">
              <div v-if="editedRowId !== props.item.id" class="feedback-text-display" style="text-align: justify !important;">
                {{ props.item.feedbackText || '-' }}
              </div>
              <v-textarea
                v-else
                v-model="editedData.feedbackText"
                :maxlength="500"
                :counter="500"
                rows="3"
                auto-grow
                hide-details
                dense
                no-resize
              ></v-textarea>
            </td>
            <td class="feedback-audio-col" :class="{ 'edited-cell': editedRowId === props.item.id }" >
              <div v-if="editedRowId !== props.item.id" style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%; gap: 8px;">
                <div v-if="props.item.feedbackAudio" style="display: flex; flex-direction: column; align-items: center; gap: 8px;">
                  <span>{{ getFileName(props.item.feedbackAudio) }}</span>
                  <!-- Use computed property to ensure audio URL is reactive -->
                  <audio 
                    :key="`audio-${props.item.id}-${props.item.feedbackAudio}-${tableKey}`"
                    :ref="`audio-${props.item.id}`"
                    :src="getAudioUrl(props.item.feedbackAudio)"
                    :disabled="false"
                    controls 
                    style="height: 32px; max-width: 200px; pointer-events: auto !important; opacity: 1 !important; display: inline-block !important;"
                    preload="metadata"
                    @loadedmetadata="onAudioLoaded($event, props.item)"
                    @canplay="onAudioCanPlay($event, props.item)"
                  >
                    Your browser does not support the audio element.
                  </audio>
                </div>
                <span v-else style="text-align: center; width: 100%;">-</span>
              </div>
              <div v-else style="display: flex; align-items: center;">
                <template v-if="isRecording">
                  <v-btn
                    small
                    color="error"
                    @click="stopRecording"
                  >
                    <v-icon left>stop</v-icon>
                    Stop Recording
                  </v-btn>
                </template>
                <template v-else-if="editedData.feedbackAudio">
                  <span>{{ editedData.feedbackAudio }}</span>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click="deleteRecord"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    @click="startRecording"
                  >
                    <v-icon left>mic</v-icon>
                    Record
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    small
                    color="primary"
                    @click="startRecording"
                  >
                    <v-icon left>mic</v-icon>
                    Record Audio
                  </v-btn>
                </template>
              </div>
            </td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">
              <div v-if="editedRowId !== props.item.id">
                {{ props.item.topicId || '-' }}
              </div>
              <v-autocomplete
                v-else
                v-model="editedData.topicId"
                :items="topicList"
                :search-input.sync="topicSearch"
                item-text="name"
                item-value="name"
                single-line
                hide-details
                dense
                clearable
                autofocus
                no-data-text="No topic found"
                placeholder="Search topic..."
                browser-autocomplete="off"
                @update:search-input="onTopicSearch"
              ></v-autocomplete>
            </td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">
              {{ formatDateTime(props.item.uploadedAt) }}
            </td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">
              {{ formatDateTime(props.item.feedbackTextCreatedAt) }}
            </td>
            <td :class="{ 'edited-cell': editedRowId === props.item.id }">
              {{ formatDateTime(props.item.feedbackAudioCreatedAt) }}
            </td>
            <td class="" :class="{ 'edited-cell': editedRowId === props.item.id }">
              <template v-if="editedRowId !== props.item.id">
                <v-btn depressed outline icon fab dark color="primary" small @click="startEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <template v-else >
                <div style="display:flex">
                    <v-btn depressed outline icon fab dark color="success" small @click="saveEdit(props.item)" class="mr-1">
                  <v-icon>save</v-icon>
                </v-btn>
                <v-btn depressed outline icon fab dark color="error" small @click="cancelEdit">
                  <v-icon>cancel</v-icon>
                </v-btn>
                </div>
              </template>
            </td>
          </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
    
    <!-- Video Popup Dialog -->
    <v-dialog
      v-model="videoDialog"
      width="75%"
      max-width="75%"
      persistent
      @click:outside="closeVideoPopup"
    >
      <v-card class="video-popup-card">
        <v-card-title class="headline">
         
          <v-spacer></v-spacer>
          <v-btn icon @click="closeVideoPopup">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="video-popup-content">
          <video
            v-if="selectedVideoUrl"
            :src="selectedVideoUrl"
            controls
            autoplay
            class="video-popup-player"
          >
            Your browser does not support the video tag.
          </video>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getSpeakingVideoList, submitFeedback, exportSpeakingVideos } from '@/api/speakingVideoAPI';
import axios from 'axios';
import { message } from '@/shared/message';
import moment from "moment/moment";

export default {
  name: 'SpeakingVideoList',
  data () {
    return {
      speakingVideos: [],
      loading: false,
      filterUserId: '',
      filterStatus: null,
      fromDate: null,
      toDate: null,
      statusItems: [
        { value: "PENDING", text: "PENDING" },
        { value: "REVIEWED", text: "REVIEWED" }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 25
      },
      totalItems: 0,
      editedRowId: null,
      editedData: {
        feedbackText: '',
        feedbackAudio: '',
        topicId: ''
      },
      originalData: {},
      topicList: [],
      topicSearch: '',
      topicSearchTimeout: null,
      isRecording: false,
      mediaRecorder: null,
      audioStream: null,
      audioChunks: [],
      recordCounter: 1,
      // Store record counter per item to avoid conflicts between different rows
      itemRecordCounters: {},
      // Table key to force re-render
      tableKey: 0,
      // Video popup dialog
      videoDialog: false,
      selectedVideoUrl: null,
      headers: [
        { text: 'User ID', value: 'userId', sortable: true },
        { text: 'Video', value: 'videoId', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Feedback Text', value: 'feedbackText', sortable: false, width: '300px' },
        { text: 'Feedback Audio', value: 'feedbackAudio', sortable: false, width: '320px' },
        { text: 'Topic', value: 'topic', sortable: true },
        { text: 'Sent Time', value: 'uploadedAt', sortable: false },
        { text: 'Text Feedback Time', value: 'feedbackTextCreatedAt', sortable: false },
        { text: 'Audio Feedback Time', value: 'feedbackAudioCreatedAt', sortable: false },
        { text: 'Actions', value: 'action', sortable: false, align: 'center', width: '100px' },
      ]
    }
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        if (!this.loading && oldVal && oldVal.page !== undefined && 
            (newVal.page !== oldVal.page || newVal.rowsPerPage !== oldVal.rowsPerPage)) {
          this.fetchSpeakingVideos();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.fetchSpeakingVideos();
    this.fetchTopics();
  },
  methods: {
    formatDateTime(timestamp) {
      if (!timestamp) return '—';
      return moment(timestamp).format('HH:mm:ss DD/MM/YYYY');
    },
    exportToCSV() {
      try {
        this.loading = true;
        
        // Prepare date filters - only use if BOTH dates are provided
        // Convert string from i-datepicker to Date object before calling getTime()
        const fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        const toDate = this.toDate ? new Date(this.toDate).getTime() : null;
        
        // Gọi async method exportSpeakingVideos
        exportSpeakingVideos('uploadedAt', 'desc', this.filterUserId || null, this.filterStatus || null, false, fromDate, toDate).then(response => {
          try {
            // Lấy dữ liệu từ response
            let videosToExport = [];
            if (response && response.data && response.data.content) {
              videosToExport = response.data.content;
            } else if (response && response.content) {
              videosToExport = response.content;
            } else if (response && Array.isArray(response)) {
              videosToExport = response;
            }
            
            // CSV header
            const headers = ['STT', 'User ID', 'Video URL', 'Sent Time', 'Status', 'Feedback Text', 'Text Feedback Time', 'Feedback Audio', 'Audio Feedback Time', 'Teacher Comment URL'];
            
            // Prepare data rows
            const rows = videosToExport.map((item, index) => {
              const itemId = item.id;
              const videoUrl = item.videoUrl || '';
              const baseUrl = window.location.origin;
              const teacherCommentUrl = videoUrl 
                ? `${baseUrl}/#/videoPlayer?itemId=${itemId}&video_url=${encodeURIComponent(videoUrl)}`
                : '';
              
              return [
                index + 1, // STT (số thứ tự)
                item.userId || '',
                item.videoUrl || '',
                this.formatDateTime(item.uploadedAt),
                this.getDisplayStatus(item.status) || '',
                item.feedbackText || '',
                this.formatDateTime(item.feedbackTextCreatedAt),
                item.feedbackAudio || '',
                this.formatDateTime(item.feedbackAudioCreatedAt),
                teacherCommentUrl
              ];
            });
            
            // Escape CSV values (handle quotes and commas)
            const escapeCSV = (value) => {
              if (value === null || value === undefined) {
                return '';
              }
              const stringValue = String(value);
              if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
                return `"${stringValue.replace(/"/g, '""')}"`;
              }
              return stringValue;
            };
            
            // Build CSV content with BOM for UTF-8 encoding (Excel compatibility)
            let csvContent = headers.map(escapeCSV).join(',') + '\n';
            csvContent += rows.map(row => row.map(escapeCSV).join(',')).join('\n');
            
            // Add BOM (Byte Order Mark) for proper UTF-8 encoding in Excel
            const BOM = '\uFEFF';
            const csvWithBOM = BOM + csvContent;
            
            // Create blob and download
            const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
            link.setAttribute('href', url);
            link.setAttribute('download', `speaking_videos_${timestamp}.csv`);
            link.style.visibility = 'hidden';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            message.success('Export CSV thành công');
          } catch (error) {
            console.error('Error processing export data:', error);
            message.error('Có lỗi xảy ra khi xử lý dữ liệu export');
          } finally {
            this.loading = false;
          }
        }).catch(error => {
          console.error('Error exporting to CSV:', error);
          message.error('Có lỗi xảy ra khi export CSV');
          this.loading = false;
        });
      } catch (error) {
        console.error('Error exporting to CSV:', error);
        message.error('Có lỗi xảy ra khi export CSV');
        this.loading = false;
      }
    },
    openVideoPopup(videoUrl) {
      if (videoUrl) {
        this.selectedVideoUrl = videoUrl;
        this.videoDialog = true;
      }
    },
    closeVideoPopup() {
      this.videoDialog = false;
      this.selectedVideoUrl = null;
    },
    showVideo(event, videoUrl) {
      const container = event.currentTarget;
      if (!container || !videoUrl) return;
      
      const img = container.querySelector('.video-thumbnail');
      const video = container.querySelector('.video-preview');
      
      if (img && video) {
        img.style.display = 'none';
        video.style.display = 'block';
        video.play().catch(err => console.error('Error playing video:', err));
      }
    },
    hideVideo(event) {
      const container = event.currentTarget;
      if (!container) return;
      
      const img = container.querySelector('.video-thumbnail');
      const video = container.querySelector('.video-preview');
      
      if (img && video) {
        video.pause();
        video.currentTime = 0;
        video.style.display = 'none';
        img.style.display = 'block';
      }
    },
    getDisplayStatus(status) {
      // Convert UPLOADED to PENDING for display
      if (status === 'UPLOADED') {
        return 'PENDING';
      }
      return status;
    },
    buildExpectedFeedbackAudioUrl(fileName) {
      if (!fileName) return '';
      if (fileName.startsWith('http://') || fileName.startsWith('https://')) return fileName;
      const base = String(fileName).replace(/\.(webm|mp3)$/i, '');
      return `https://static.babilala.vn/uploads/kidnew/record-feedback/${base}.mp3`;
    },
    getAudioUrl(audioPath) {
      if (!audioPath) {
        return '';
      }
      // If already a full URL, return as is
      if (audioPath.startsWith('http://') || audioPath.startsWith('https://')) {
        return audioPath;
      }
      // If starts with /, it's a relative path, add base URL
      if (audioPath.startsWith('/')) {
        return 'https://static.babilala.vn' + audioPath;
      }
      // Otherwise, assume it's already a full path or return as is
      return audioPath;
    },
    getFileName(filePath) {
      if (!filePath) return '';
      // Extract filename from path (handle both / and \ separators)
      const lastSlash = Math.max(filePath.lastIndexOf('/'), filePath.lastIndexOf('\\'));
      return lastSlash !== -1 ? filePath.substring(lastSlash + 1) : filePath;
    },
    onAudioLoaded(event, item) {
      const audio = event.target;
      console.log('onAudioLoaded - audio element loaded for item:', item.id, 'feedbackAudio:', item.feedbackAudio);
      console.log('onAudioLoaded - audio.disabled:', audio.disabled);
      console.log('onAudioLoaded - audio.controls:', audio.controls);
      console.log('onAudioLoaded - audio.style.pointerEvents:', audio.style.pointerEvents);
      console.log('onAudioLoaded - audio.style.opacity:', audio.style.opacity);
      // Ensure audio is not disabled
      if (audio.disabled) {
        console.warn('onAudioLoaded - Audio was disabled, enabling it');
        audio.disabled = false;
      }
      audio.controls = true;
      audio.style.pointerEvents = 'auto';
      audio.style.opacity = '1';
    },
    onAudioCanPlay(event, item) {
      const audio = event.target;
      console.log('onAudioCanPlay - audio can play for item:', item.id, 'feedbackAudio:', item.feedbackAudio);
      console.log('onAudioCanPlay - audio.disabled:', audio.disabled);
      console.log('onAudioCanPlay - audio.controls:', audio.controls);
      // Ensure audio is not disabled
      if (audio.disabled) {
        console.warn('onAudioCanPlay - Audio was disabled, enabling it');
        audio.disabled = false;
      }
      audio.controls = true;
      audio.style.pointerEvents = 'auto';
      audio.style.opacity = '1';
    },
    async fetchTopics(search = '') {
      try {
        const params = search ? { search: search } : {};
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/topic`, { params });
        this.topicList = response || [];
      } catch (error) {
        console.error('Error fetching topics:', error);
        this.topicList = [];
      }
    },
    onTopicSearch(search) {
      // Clear existing timeout
      if (this.topicSearchTimeout) {
        clearTimeout(this.topicSearchTimeout);
      }
      
      // Debounce search - wait 300ms after user stops typing
      this.topicSearchTimeout = setTimeout(() => {
        if (search !== null && search !== undefined) {
          this.fetchTopics(search);
        } else {
          // If search is cleared, fetch all topics
          this.fetchTopics();
        }
      }, 300);
    },
    startEdit(item) {
      this.editedRowId = item.id;
      this.originalData = {
        feedbackText: item.feedbackText || '',
        feedbackAudio: item.feedbackAudio || '',
        topicId: item.topicId || ''
      };
      this.editedData = {
        feedbackText: item.feedbackText || '',
        feedbackAudio: this.getFileName(item.feedbackAudio || ''),
        topicId: item.topicId || ''
      };
      // Initialize record counter for this videoId based on existing feedbackAudio
      const videoId = item.videoId || item.id;
      if (!this.itemRecordCounters[videoId]) {
        // Parse counter from existing feedbackAudio filename if exists
        // Format: record_{videoId}_{counter}.mp3 or record_{videoId}_{counter}.webm
        let initialCounter = 0;
        if (item.feedbackAudio) {
          const fileName = this.getFileName(item.feedbackAudio);
          // Extract counter from filename: record_{videoId}_{counter}.ext
          const match = fileName.match(new RegExp(`^record_${videoId}_(\\d+)\\.(webm|mp3)$`));
          if (match && match[1]) {
            initialCounter = parseInt(match[1], 10);
            console.log(`startEdit - Parsed counter from existing file: ${fileName} -> counter: ${initialCounter}`);
          }
        }
        this.itemRecordCounters[videoId] = initialCounter;
        console.log(`startEdit - Initialized counter for videoId ${videoId}: ${initialCounter}`);
      } else {
        console.log(`startEdit - Counter for videoId ${videoId} already exists: ${this.itemRecordCounters[videoId]}`);
      }
      // Only reset audioBlob and related recording state
      this.audioBlob = null;
      this.audioChunks = [];
      if (this.mediaRecorder) {
        this.mediaRecorder = null;
      }
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(track => track.stop());
        this.audioStream = null;
      }
      this.isRecording = false;
      // Load all topics when starting edit
      this.topicSearch = '';
      this.fetchTopics();
    },
    cancelEdit() {
      // Stop recording if in progress
      if (this.isRecording && this.mediaRecorder) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(track => track.stop());
        this.audioStream = null;
      }
      // Clear search timeout if exists
      if (this.topicSearchTimeout) {
        clearTimeout(this.topicSearchTimeout);
        this.topicSearchTimeout = null;
      }
      this.topicSearch = '';
      this.editedRowId = null;
      this.editedData = {
        feedbackText: '',
        feedbackAudio: '',
        topicId: ''
      };
      this.originalData = {};
      this.audioChunks = [];
      this.mediaRecorder = null;
    },
    async startRecording() {
      try {
        // Get current item being edited
        const currentItemId = this.editedRowId;
        if (!currentItemId) {
          console.error('No item is being edited');
          return;
        }
        
        // Find the current item to get videoId
        const currentItem = this.speakingVideos.find(item => item.id === currentItemId);
        if (!currentItem) {
          console.error('Current item not found');
          return;
        }
        
        // Use videoId if available, otherwise fall back to item.id
        const videoId = currentItem.videoId || currentItem.id;
        
        // Stop existing recording if any
        if (this.isRecording && this.mediaRecorder) {
          this.mediaRecorder.stop();
        }
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => track.stop());
        }
        
        // Initialize counter for this videoId if not exists
        if (!this.itemRecordCounters[videoId]) {
          this.itemRecordCounters[videoId] = 0;
        }
        
        // IMPORTANT: Increment recordCounter for this specific videoId FIRST, then use it
        // This ensures each new recording gets a unique number per video
        this.itemRecordCounters[videoId]++;
        const currentRecordNumber = this.itemRecordCounters[videoId];
        console.log('startRecording - videoId:', videoId, 'recordCounter incremented to:', currentRecordNumber);
        
        // Delete existing record name (only one record allowed)
        this.editedData.feedbackAudio = '';
        this.audioChunks = [];
        
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.audioStream = stream;
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];
        
        // Store videoId in closure for onstop callback
        const videoIdForCallback = videoId;
        const recordNumberForCallback = currentRecordNumber;
        
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };
        
        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          // Use format: record_{videoId}_{counter}.webm to avoid conflicts between different rows
          const fileName = `record_${videoIdForCallback}_${recordNumberForCallback}.webm`;
          this.editedData.feedbackAudio = fileName;
          console.log('Recording stopped - Set editedData.feedbackAudio to:', fileName);
          console.log('Current editedData:', JSON.stringify(this.editedData));
          
          // Stop all tracks to release microphone
          if (this.audioStream) {
            this.audioStream.getTracks().forEach(track => track.stop());
            this.audioStream = null;
          }
          this.isRecording = false;
        };
        
        this.mediaRecorder.start();
        this.isRecording = true;
      } catch (error) {
        console.error('Error accessing microphone:', error);
        message.error('Không thể truy cập microphone. Vui lòng kiểm tra quyền truy cập.');
        this.isRecording = false;
        if (this.audioStream) {
          this.audioStream.getTracks().forEach(track => track.stop());
          this.audioStream = null;
        }
      }
    },
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },
    deleteRecord() {
      this.editedData.feedbackAudio = '';
      this.audioChunks = [];
      this.audioBlob = null;
      // Don't reset recordCounter here - keep it incrementing for multiple records in same edit session
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
      if (this.audioStream) {
        this.audioStream.getTracks().forEach(track => track.stop());
        this.audioStream = null;
      }
    },
    async saveEdit(item) {
      try {
        // Convert audioBlob to File if exists
        // IMPORTANT: Capture values IMMEDIATELY and use a deep copy to prevent Vue reactivity issues
        const audioBlobToSave = this.audioBlob;
        // Use a local variable to capture the value immediately, not a reactive reference
        const audioFileNameToSave = String(this.editedData.feedbackAudio || '');
        
        console.log('saveEdit - audioBlob exists:', !!audioBlobToSave);
        console.log('saveEdit - audioFileName (captured):', audioFileNameToSave);
        console.log('saveEdit - editedData.feedbackAudio (current):', this.editedData.feedbackAudio);
        console.log('saveEdit - recordCounter:', this.recordCounter);
        console.log('saveEdit - full editedData:', JSON.stringify(this.editedData));
        
        let audioFile = null;
        if (audioBlobToSave && audioFileNameToSave) {
          audioFile = new File([audioBlobToSave], audioFileNameToSave, { type: 'audio/webm' });
          console.log('Created File object with name:', audioFile.name);
        } else {
          console.warn('Cannot create audio file - audioBlob:', !!audioBlobToSave, 'fileName:', audioFileNameToSave);
        }

        const response = await submitFeedback(
          item.id,
          this.editedData.topicId || null,
          this.editedData.feedbackText || null,
          audioFile
        );
        
        if (response && response.success) {
          // Update only the edited row locally (do NOT reload the whole table)
          const idx = this.speakingVideos.findIndex(v => String(v.id) === String(item.id));
          if (idx !== -1) {
            const now = Date.now();
            const updated = { ...this.speakingVideos[idx] };
            updated.topicId = this.editedData.topicId || null;
            updated.feedbackText = this.editedData.feedbackText || null;
            if (this.editedData.feedbackText) {
              updated.feedbackTextCreatedAt = now;
            }
            // Only update audio when we actually uploaded a new file
            if (audioFile && audioFileNameToSave) {
              updated.feedbackAudio = this.buildExpectedFeedbackAudioUrl(audioFileNameToSave);
              updated.feedbackAudioCreatedAt = now;
            }
            updated.hasReview = true;
            updated.status = 'REVIEWED';
            updated.reviewedAt = now;
            this.$set(this.speakingVideos, idx, updated);
          }

          message.success('Cập nhật thành công');
          this.cancelEdit();
        } else {
          message.error(response.description || 'Cập nhật thất bại');
        }
      } catch (error) {
        console.error('Error saving feedback:', error);
        message.error('Có lỗi xảy ra khi cập nhật');
      }
    },
    onFilterChange() {
      this.pagination.page = 1;
      this.fetchSpeakingVideos();
    },
    async fetchSpeakingVideos(forceRefresh = false) {
      this.loading = true;

      try {
        // Backend uses 0-based page, frontend uses 1-based
        const page = (this.pagination.page || 1) - 1;
        const size = this.pagination.rowsPerPage || 25;
        
        const userId = this.filterUserId && this.filterUserId.trim() !== '' ? this.filterUserId.trim() : null;
        const status = this.filterStatus || null;
        
        // Prepare date filters - only use if BOTH dates are provided
        // Convert string from i-datepicker to Date object before calling getTime()
        const fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        const toDate = this.toDate ? new Date(this.toDate).getTime() : null;
        
        // Pass forceRefresh flag to API
        const response = await getSpeakingVideoList(page, size, 'uploadedAt', 'desc', userId, status, forceRefresh, fromDate, toDate);
        // API returns PagedResponse with structure: { content: [], totalElements: number, ... }
        if (response && response.content) {
          // Force Vue to create new array reference to trigger reactivity
          // Use JSON parse/stringify to ensure deep copy and trigger reactivity
          this.speakingVideos = JSON.parse(JSON.stringify(response.content));
          this.totalItems = response.totalElements ? Number(response.totalElements) : 0;
          // Debug: Log feedbackAudio values after reload
          if (forceRefresh) {
            this.speakingVideos.forEach((item, index) => {
              if (item.feedbackAudio) {
                console.log(`  Item ${index} (id: ${item.id}, videoId: ${item.videoId}): ${item.feedbackAudio}`);
                console.log(`  Item ${index} - feedbackAudio exists check:`, !!item.feedbackAudio, 'value:', item.feedbackAudio);
              } else {
                console.log(`  Item ${index} - NO feedbackAudio`);
              }
            });
          }
        } else {
          this.speakingVideos = [];
          this.totalItems = 0;
        }
      } catch (error) {
        console.error('Error fetching speaking videos:', error);
        this.speakingVideos = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
/* Use /deep/ to penetrate scoped styles and override Vuetify */
.speaking-video-list >>> .v-data-table thead th:nth-child(4),
.speaking-video-list >>> .v-table thead th:nth-child(4) {
  text-align: left !important;
}
.speaking-video-list >>> .v-data-table tbody td:nth-child(4),
.speaking-video-list >>> .v-table tbody td:nth-child(4) {
  text-align: left !important;
}
.speaking-video-list >>> .v-data-table thead th:nth-child(5),
.speaking-video-list >>> .v-table thead th:nth-child(5) {
  text-align: center !important;
}
.speaking-video-list >>> .v-data-table tbody td:nth-child(5),
.speaking-video-list >>> .v-table tbody td:nth-child(5) {
  text-align: center !important;
}
/* Override for specific class names */
.speaking-video-list >>> .v-data-table tbody td.feedback-text-col,
.speaking-video-list >>> .v-table tbody td.feedback-text-col {
  text-align: left !important;
}

.speaking-video-list {
  padding: 20px;
}
/* Export button styling */
.speaking-video-list .export-button {
  width: 100px !important;
  height: 39px !important;
  white-space: nowrap;
  margin-left: 10px;
  padding: 0 10px !important;
}
/* Table wrapper for horizontal scroll */
.speaking-video-list .table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 4px;
}
.speaking-video-list .table-wrapper .v-data-table {
  min-width: 100%;
}
/* Ensure table rows can adjust height automatically */
.speaking-video-list .v-data-table tbody tr {
  height: auto !important;
}
.speaking-video-list .v-data-table tbody td {
  height: auto !important;
  padding: 15px !important;
}
.speaking-video-list .v-data-table thead th {
  padding: 15px !important;
}
/* Override v-data-table default white-space for feedback text column */
.speaking-video-list .v-data-table tbody td.feedback-text-col {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  text-align: left !important;
}
.speaking-video-list .v-data-table tbody td.feedback-text-col > div {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
  text-align: left !important;
}
.speaking-video-list .v-data-table thead th:nth-child(4),
.speaking-video-list .v-data-table tbody td:nth-child(4) {
  white-space: normal !important;
  overflow: visible !important;
  max-width: 300px !important;
  width: 300px !important;
  text-align: left !important;
}
.speaking-video-list .v-data-table thead th:nth-child(4) {
  text-align: left !important;
}
/* Feedback Audio column - 5th column (index 5) */
.speaking-video-list .v-data-table thead th:nth-child(5) {
  text-align: center !important;
}
.speaking-video-list .v-data-table tbody td:nth-child(5) {
  text-align: center !important;
}

.edited-cell {
  background-color: #e3f2fd !important;
}
.video-thumbnail-container {
  position: relative;
  display: inline-block;
  width: 120px !important;
  height: 80px !important;
  min-width: 120px;
  min-height: 80px;
  max-width: 120px;
  max-height: 80px;
  overflow: hidden;
  border-radius: 4px;
  cursor: pointer;
}
.video-popup-card {
  width: 75vw;
  max-width: 75vw;
}
.video-popup-content {
  padding: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
}
.video-popup-player {
  width: 100%;
  height: 75vh;
  max-height: 75vh;
  object-fit: contain;
}
.video-thumbnail {
  width: 120px !important;
  height: 80px !important;
  min-width: 120px;
  min-height: 80px;
  max-width: 120px;
  max-height: 80px;
  object-fit: cover;
  display: block;
}
.video-preview {
  width: 120px !important;
  height: 80px !important;
  min-width: 120px;
  min-height: 80px;
  max-width: 120px;
  max-height: 80px;
  object-fit: cover;
  display: block;
}

.feedback-text-col * {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  text-align: justify !important;
}

/* Ensure audio controls are not disabled */
.speaking-video-list audio {
  pointer-events: auto !important;
  opacity: 1 !important;
  cursor: pointer !important;
  display: inline-block !important;
}
.speaking-video-list audio:disabled {
  pointer-events: auto !important;
  opacity: 1 !important;
}
.speaking-video-list audio[disabled] {
  pointer-events: auto !important;
  opacity: 1 !important;
}
.speaking-video-list audio::-webkit-media-controls-play-button,
.speaking-video-list audio::-webkit-media-controls-panel {
  pointer-events: auto !important;
}
/* Override any v-data-table styles that might disable audio */
.speaking-video-list .v-data-table audio {
  pointer-events: auto !important;
  opacity: 1 !important;
  cursor: pointer !important;
}
.speaking-video-list .v-data-table td audio {
  pointer-events: auto !important;
  opacity: 1 !important;
  cursor: pointer !important;
}
</style>

<style>
/* Non-scoped styles to override Vuetify completely */
.speaking-video-list .v-data-table thead th:nth-child(4),
.speaking-video-list .v-table thead th:nth-child(4),
.speaking-video-list .v-datatable thead th:nth-child(4) {
  text-align: left !important;
}

.speaking-video-list .v-data-table tbody td:nth-child(4),
.speaking-video-list .v-table tbody td:nth-child(4),
.speaking-video-list .v-datatable tbody td:nth-child(4) {
  text-align: left !important;
}

.speaking-video-list .v-data-table thead th:nth-child(5),
.speaking-video-list .v-table thead th:nth-child(5),
.speaking-video-list .v-datatable thead th:nth-child(5) {
  text-align: center !important;
}

.speaking-video-list .v-data-table tbody td:nth-child(5),
.speaking-video-list .v-table tbody td:nth-child(5),
.speaking-video-list .v-datatable tbody td:nth-child(5) {
  text-align: center !important;
}

.speaking-video-list .v-data-table tbody td.feedback-text-col,
.speaking-video-list .v-table tbody td.feedback-text-col,
.speaking-video-list .v-datatable tbody td.feedback-text-col {
  text-align: left !important;
}

/* Set padding for all table cells */
.speaking-video-list .v-data-table thead th,
.speaking-video-list .v-data-table tbody td,
.speaking-video-list .v-table thead th,
.speaking-video-list .v-table tbody td,
.speaking-video-list .v-datatable thead th,
.speaking-video-list .v-datatable tbody td {
  padding: 15px !important;
}
</style>
